<ng-container *appTranslate="let t">
  <new-ui-dashboard-card>
    <ng-template #header>
      <new-ui-dashboard-card-header [title]="t('dashboard.birthdays.title')">
        <p-select
          [(ngModel)]="selectedTimeframe"
          [options]="timeframeOptions"
          optionLabel="label"
          optionValue="value"
          (onChange)="onBirthdayFilterChanged()"
        />
      </new-ui-dashboard-card-header>
    </ng-template>

    @defer (when birthdays()) {
      @if (birthdays().length > 0) {
        <ul class="col overflow-auto">
          @for (birthday of birthdays(); track $index) {
            <li class="row">
              <a
                class="row grow"
                [routerLink]="['/app/candidates/edit', birthday.organizationId, birthday.candidateId]"
              >
                <p-avatar shape="circle" class="size-8">
                  <img
                    [src]="birthday.avatarUrl | async"
                    default="/assets/user.jpeg"
                    class="w-full h-full"
                    style="object-fit: cover"
                  />
                </p-avatar>

                <div class="col gap-0">
                  <span class="text-body-text-semibold">{{
                    t("dashboard.birthdays.birthday", { name: birthday.name })
                  }}</span>
                  <span class="text-caption-text-regular text-text-caption">{{ birthday.birthday | appDate }}</span>
                </div>
              </a>
            </li>
          }
        </ul>
      } @else {
        <ui-emptystate
          class="py-[3%]"
          image="/assets/layout/images/new-ui/goal.png"
          [caption]="t('dashboard.birthdays.emptyState.title')"
          [description]="t('dashboard.birthdays.emptyState.description')"
        />
      }
    } @placeholder {
      <ul class="col gap-3">
        @for (item of [1, 2, 3, 4]; track item) {
          <li class="row gap-3 p-1">
            <p-skeleton shape="circle" size="2rem" />
            <div class="col gap-1 grow">
              <p-skeleton class="h-4 w-36" />
              <p-skeleton class="h-3 w-20" />
            </div>
          </li>
        }
      </ul>
    }
  </new-ui-dashboard-card>
</ng-container>
